module.exports = __webpack_public_path__ + "static/src/content/silks/yes_yes_yes.27bb7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/silks/yes_yes_yes.png
// module id = ILOl
// module chunks = 0